// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"8b1b0bee","295":"53c314a1","457":"bd35da34"}[chunkId] + ".chunk.js";
};